import init from './thing'

const word =
{
    ...init
};

export default word ;
